import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePermission } from "../../../../context/permissionsContext";
import { useUser } from "../../../../context/userContext";
import DashboardApi from "../../../../services/api/dashboardApi";
import { dashboardTileArray } from "../../../../helpers/adminConstants/AdminConstants";
import { PlaceholderImg } from "../../../../components/styled/AllImages";
import RequestsApi from "../../../../services/api/requestsApi";
import echo from "../../../../echo";
import { Col, Row } from "react-bootstrap";
import PendingReceivedReqs from "./PendingReceivedReqs";
import PendingSentReqs from "./PendingSentReqs";
import { Box } from "../../../../components/styled/Elements";
import CustomTile from "../../../../components/common/statusTiles/CustomTile";
import { toast } from "react-toastify";

const DashboardView = () => {
  const { checkPermission } = usePermission();
  const { user } = useUser();
  const userId = Number(user?.id);

  const [stats, setStats] = useState(dashboardTileArray);
  const [receivedRequests, setReceivedRequests] = useState([]);
  const [sentRequests, setSentRequests] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isResolvingRequest, setIsResolvingRequest] = useState({});
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const getStats = async () => {
    try {
      setIsFetching(true);
      const response = await DashboardApi.tiles();
      if (response?.data) {
        const updatedTileArray = dashboardTileArray.map((tile) => {
          switch (tile.title) {
            case "total_cabinets":
              return { ...tile, count: response?.data?.cabinets || tile.count };
            case "total_files":
              return {
                ...tile,
                count: response?.data?.cabinetFiles || tile.count,
              };
            case "total_archives":
              return {
                ...tile,
                count: response?.data?.fileArchives || tile.count,
              };
            case "total_users":
              return { ...tile, count: response?.data?.users || tile.count };
            case "total_requests":
              return {
                ...tile,
                count: response?.data?.totalRequests || tile.count,
              };
            case "total_open_requests":
              return {
                ...tile,
                count: response?.data?.openRequests || tile.count,
              };
            case "total_canceled_requests":
              return {
                ...tile,
                count: response?.data?.closeRequests || tile.count,
              };
            case "total_org_structure":
              return {
                ...tile,
                count: response?.data?.locations || tile.count,
              };

            default:
              return tile;
          }
        });
        if (response?.data?.pendingReceivedRequests) {
          const mappedRequests = response?.data?.pendingReceivedRequests?.map(
            (req) => {
              const getInfoData = (item) => {
                const baseData = {
                  cabinetName:
                    item.module_parent_detail?.cabinet_name?.name || null,
                };

                switch (Number(item.module_id)) {
                  case 1:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("cabinet_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  case 2:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: item.module_parent_detail.name,
                      },
                      {
                        title: t("file_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("file_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  case 3:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: baseData.cabinetName,
                      },
                      {
                        title: t("file_name"),
                        value: item.module_parent_detail?.name || null,
                      },
                      {
                        title: t("archive_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("archive_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  default:
                    return [];
                }
              };
              return {
                id: req.id,
                name: req.user.name,
                subLabel: `${req.user.department} (${req.user.location})`,
                requestedFor: {
                  module_type: req.module_type,
                  infoData: getInfoData(req),
                },
                profilePic: req.user.profile
                  ? `${ASSET_URL}/${req.user.profile}`
                  : PlaceholderImg,
              };
            }
          );
          setReceivedRequests(mappedRequests);
        }
        if (response?.data?.pendingSentRequests) {
          const mappedRequests = response?.data?.pendingSentRequests?.map(
            (req) => {
              const getInfoData = (item) => {
                const baseData = {
                  cabinetName:
                    item.module_parent_detail?.cabinet_name?.name || null,
                };

                switch (Number(item.module_id)) {
                  case 1:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("cabinet_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  case 2:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: item.module_parent_detail.name,
                      },
                      {
                        title: t("file_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("file_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  case 3:
                    return [
                      {
                        title: t("cabinet_name"),
                        value: baseData.cabinetName,
                      },
                      {
                        title: t("file_name"),
                        value: item.module_parent_detail?.name || null,
                      },
                      {
                        title: t("archive_name"),
                        value: item.module_name,
                      },
                      {
                        title: t("archive_id"),
                        value: item.module_reference_number,
                      },
                    ];

                  default:
                    return [];
                }
              };
              return {
                id: req.id,
                name: req.user.name,
                subLabel: `${req.user.department} (${req.user.location})`,
                requestedFor: {
                  module_type: req.module_type,
                  infoData: getInfoData(req),
                },
                profilePic: req.user.profile
                  ? `${ASSET_URL}/${req.user.profile}`
                  : PlaceholderImg,
              };
            }
          );
          setSentRequests(mappedRequests);
        }

        setStats(updatedTileArray);
      }
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  const acceptRejectRequest = async (requestId, decision, reason) => {
    const formData = new FormData();
    formData.append("request_id", requestId);
    formData.append("decision", decision);
    reason && formData.append("reject_decision_reason", reason);

    try {
      setIsResolvingRequest((prev) => ({
        ...prev,
        [`${requestId}-${decision}`]: true,
      }));
      const { code, message } = await RequestsApi.acceptRejectRequest(formData);
      if (code === 200) {
        getStats();
        if (decision == 1) {
          toast.success(t("request_approved"));
        } else if (decision == 2) {
          toast.success(t("request_rejected"));
        } else if (decision == 0) {
          toast.success(t("request_cancelled"));
        }
      }
      if (code === 100) toast.error(t(message));
    } catch (error) {
    } finally {
      // setIsResolvingRequest({ approve: false, reject: false, cancel: false });
      setIsResolvingRequest((prev) => ({
        ...prev,
        [`${requestId}-${decision}`]: true,
      }));
    }
  };

  useEffect(() => {
    getStats();

    const channel = echo.channel("cloud-archive");

    channel.listen(".request-updated", (event) => {
      if (
        Array.isArray(event) &&
        event.length > 0 &&
        event
          .filter((e) => Number(e.to_user_id) === userId)
          .some((e) => Number(e.to_user_id) === userId)
      ) {
        getStats();
      }
    });

    return () => {
      echo.leaveChannel("cloud-archive");
    };
  }, [language]);
  return (
    <Box className="content-container">
      <Row>
        {stats.map(
          (tile, key) =>
            checkPermission(tile.collection, tile.action, tile?.feature) && (
              <Col xl={3} lg={6} sm={12} className="my-2" key={key}>
                <CustomTile {...tile} />
              </Col>
            )
        )}
      </Row>
      {checkPermission(5, 1, 4) && (
        <Row className="mt-3">
          <Col lg={6} md={12} className="mb-3">
            <PendingReceivedReqs
              requests={receivedRequests}
              acceptRejectRequest={acceptRejectRequest}
              isResolvingRequest={isResolvingRequest}
              isLoading={isFetching}
            />
          </Col>
          <Col lg={6} md={12} className="mb-3">
            <PendingSentReqs
              requests={sentRequests}
              acceptRejectRequest={acceptRejectRequest}
              isResolvingRequest={isResolvingRequest}
              isLoading={isFetching}
            />
          </Col>
        </Row>
      )}
    </Box>
  );
};

export default DashboardView;
